import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
// import { LayoutPage } from './layout/layout.page';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { AuthGuard } from './core/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    //remove AuthGuard Temp -- until 2fa issue fixed from BE.
   // canActivate: [],
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule)
      },
      {
        path: 'transactions',
        loadChildren: () => import('./pages/transactions/transactions.module').then(m => m.TransactionsPageModule)
      },
      {
        path: 'credit-score',
        loadChildren: () => import('./pages/credit-score/credit-score.module').then(m => m.CreditScorePageModule)
      },
      {
        path: 'offers',
        loadChildren: () => import('./pages/offers/offers.module').then(m => m.OffersPageModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./pages/notifications-detail/notifications-detail.module').then(m => m.NotificationsDetailPageModule)
      }
    ]
  },
  {
    path: 'register',
    loadChildren: () => import('./auth/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./auth/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
  },
  {
    path: 'verifyOTP',
    loadChildren: () => import('./auth/verify-otp/verify-otp.module').then(m => m.VerifyOTPPageModule)
  },
  {
    path: '**',
    redirectTo: 'login'
  },
  {
    path: 'offers',
    loadChildren: () => import('./pages/offers/offers.module').then(m => m.OffersPageModule)
  },
  {
    path: 'credit-score',
    loadChildren: () => import('./pages/credit-score/credit-score.module').then(m => m.CreditScorePageModule)
  },
  {
    path: 'verify-otp',
    loadChildren: () => import('./auth/verify-otp/verify-otp.module').then(m => m.VerifyOTPPageModule)
  },
  {
    path: 'notifications-detail',
    loadChildren: () => import('./pages/notifications-detail/notifications-detail.module').then(m => m.NotificationsDetailPageModule)
  }




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
